export function callIfExists(func, ...params) {
  if (typeof func === "function") {
    return func(...params);
  }
  return null;
}

export default {callIfExists};
